import { Component, EventEmitter, Input, Output, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";

@Component({
    selector: 'mwp-datepicker',
    templateUrl: './datepicker.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DatePickerComponent implements OnInit {
    @Input() public form: FormGroup;
    @Input() public nameForControl: string;
    @Input() public labelName: string = "MM/DD/YYYY";
    @Input() public hideLabel: boolean;
    @Input() public autoTranslate: boolean = true;
    @Input() public minDate: Date;
    @Input() public maxDate: Date;

    @Output() public emitSelectedDate: EventEmitter<any> = new EventEmitter();

    public datePickerMin: Date = new Date(1900, 0, 1);
    public datePickerMax: Date = new Date(2100, 0, 1);

    constructor(
    ) {
    }

    ngOnInit(): void {
        if (this.minDate)
            this.datePickerMin = new Date(this.minDate);

        if (this.maxDate)
            this.datePickerMax = new Date(this.maxDate);
    }

    public onSelectionChanged(event: MatDatepickerInputEvent<Date>): void {
        if (event.value) {
            this.emitSelectedDate.emit(event.value);
        }
    }
}